import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6e5a168"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "companies-spark" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = {
  key: 0,
  class: "bg-white p-4 border border-gray-200 text-sm select-none flex flex-col items-center justify-center"
}
const _hoisted_5 = { class: "flex flex-col items-center justify-center mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none mt-1 text-sm text-gray-400" }, " Загрузка данных... ", -1))
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "PaginationHolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loader = _resolveComponent("loader")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_delivery_companies_list_item = _resolveComponent("delivery-companies-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Компании Spark.kz" }),
      (_ctx.havePermissions(['call-center-companies-store', 'all-root-permission']))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/companies/spark-kz/create"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "primary small mr-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить компанию ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.state.companies.is_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_loader, { class: "primary" }),
              _hoisted_6
            ])
          ]))
        : (_ctx.state.companies.is_failed)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 1,
              loading: _ctx.state.companies.is_loading,
              text: "При получении списка компаний произошла ошибка",
              onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadCompanies(_ctx.state.companies.pagination.current_page)))
            }, null, 8, ["loading"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_new_limit, {
                  disabled: _ctx.state.companies.is_loading,
                  "total-items": _ctx.state.companies.pagination.total_items,
                  value: _ctx.state.limit,
                  onChange: _ctx.onLimitChange
                }, null, 8, ["disabled", "total-items", "value", "onChange"]),
                _createVNode(_component_new_pagination, {
                  class: "ml-6",
                  disabled: _ctx.state.companies.is_loading,
                  "current-page": _ctx.state.companies.pagination.current_page,
                  "total-pages": _ctx.state.companies.pagination.total_pages,
                  onChangePage: _ctx.onChangePage
                }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
              ]),
              _createVNode(_component_list, {
                loading: _ctx.state.companies.is_loading,
                items: _ctx.state.companies.list
              }, {
                item: _withCtx(({ item }) => [
                  _createVNode(_component_delivery_companies_list_item, {
                    item: item,
                    onDeleted: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.state.companies.pagination.current_page)))
                  }, null, 8, ["item"])
                ]),
                _: 1
              }, 8, ["loading", "items"])
            ]))
    ])
  ]))
}